<template>
  <div>
    <div
      class="row rowOpenvidu"
      v-bind:style="{
        display:
          item.evento && item.evento.servidorTipo == 'openvidu'
            ? 'block'
            : 'none',
      }"
    >
      <div class="col-md-12 text-center" style="padding: 0">
        <div id="subscriber"></div>
      </div>
    </div>
    <div
      class="row rowAnt"
      v-bind:style="{
        display:
          item.evento && item.evento.servidorTipo == 'ant' ? 'block' : 'none',
      }"
    >
      <div class="col-md-12 text-center" style="padding: 0">
        <video id="remoteVideo" autoplay controls playsinline></video>
      </div>
    </div>
    <div
      class="row rowFlash"
      v-bind:style="{
        display:
          item.evento && item.evento.servidorTipo == 'sh' ? 'block' : 'none',
      }"
    >
      <div class="col-md-12 text-center" style="padding: 0">
        <div id="playFlash">
          <video id="flashPlayVideo" controls="controls"></video>
        </div>
      </div>
    </div>
    <div
      v-if="retornaSite() !== '7live'"
      class="row rowMS"
      v-bind:style="{
        display:
          item.evento && item.evento.servidorTipo == 'ms' ? 'block' : 'none',
      }"
    >
      <div class="col-md-12 text-center" style="padding: 0">
        <video
          id="msPlayVideo"
          autoplay
          controls
          playsinline
          style="display: none"
          :muted="audioMudo"
        ></video>
      </div>
    </div>
    <div
      v-if="retornaSite() !== '7live'"
      class="row rowMS"
      v-bind:style="{
        display:
          options.replay && item.evento && item.evento.servidorTipo == 'ms'
            ? 'block'
            : 'none',
      }"
    >
      <div class="col-md-12 text-center" style="padding: 0">
        <video
          id="msPlayVideoBackup"
          autoplay
          controls
          playsinline
          :muted="audioMudo"
        ></video>
      </div>
    </div>
    <div
      v-if="retornaSite() == '7live'"
      id="frameVideo"
      style="position: relative"
      v-bind:style="{
        display:
          item.evento && item.evento.servidorTipo == 'ms' ? 'block' : 'none',
      }"
    >
      <video
        id="msPlayVideo"
        autoplay
        controls
        playsinline
        style="display: none; height: 100%; max-height: 100%"
        :muted="audioMudo"
      ></video>
    </div>
    <div
      class="row rowFuncoes"
      v-bind:style="{
        display:
          item.evento && item.evento.servidorTipo == 'ms' && false == true
            ? 'block'
            : 'none',
      }"
    >
      <div class="col-md-12 text-center" style="padding: 0">
        <button @click="fullScreen()">Tela Cheia</button>
      </div>
    </div>
    <div class="row" v-if="!item.erro">
      <div
        class="col-md-12 text-center"
        style="padding: 0"
        v-if="
          propSofaScore &&
          item.evento &&
          (item.evento.sofaScoreId || item.evento.williamHillId)
        "
      >
        <div
          v-if="item.evento.sofaScoreId && options.sofascore && !options.sofascoreFloat"
          style="height: 86px;"
        >
          <iframe
            width="100%"
            height="86"
            frameborder="0"
            scrolling="no"
            :src="'/sofascore/' + item.evento.sofaScoreId"
          ></iframe>
        </div>
        <div v-if="item.evento.williamHillId && options.williamhill">
          <iframe
            width="100%"
            height="700"
            frameborder="0"
            scrolling="no"
            :src="
              'https://score.kwddw.com/scoreboards/app/football/index.html?eventId=' +
              william(item.evento.williamHillId) +
              '&sport=football&locale=pt-pt'
            "
          ></iframe>
        </div>
        
        <div 
          v-if="item.evento.williamHillId && options.williamhill && options.williamhillFloat"
          class="floating-iframe-container"
          :style="{
            left: floatingIframe.x + 'px',
            top: floatingIframe.y + 'px',
            width: floatingIframe.width + 'px',
            height: floatingIframe.height + 'px',
            opacity: floatingIframe.opacity,
            zIndex: 9999
          }"
        >
          <div 
            class="iframe-header" 
            @mousedown="startDrag"
            :class="{ 'header-hidden': !floatingIframe.showControls }"
          >
            <div class="iframe-controls">
              <button @click.stop="decreaseOpacity" title="Diminuir transparência">-</button>
              <span>{{ Math.round(floatingIframe.opacity * 100) }}%</span>
              <button @click.stop="increaseOpacity" title="Aumentar transparência">+</button>
              
              <span class="separator">|</span>
              
              <button @click.stop="scrollUp" title="Rolar para cima">▲</button>
              <button @click.stop="scrollDown" title="Rolar para baixo">▼</button>
              <button @click.stop="resetScroll" title="Recarregar iframe">↻</button>
            </div>
          </div>
          <div 
            class="iframe-content-wrapper"
            @click="handleWrapperClick"
            :style="{
              height: floatingIframe.showControls ? 'calc(100% - 40px)' : '100%'
            }"
          >
            <div 
              class="iframe-scroll-container"
              :style="{
                marginTop: floatingIframe.scrollY + 'px'
              }"
            >
              <iframe
                width="100%"
                :height="floatingIframe.iframeHeight + 'px'"
                frameborder="0"
                scrolling="no"
                :src="
                  'https://score.kwddw.com/scoreboards/app/football/index.html?eventId=' +
                  william(item.evento.williamHillId) +
                  '&sport=football&locale=pt-pt'
                "
              ></iframe>
            </div>
          </div>
          
          <div class="resize-handle" @mousedown="startResize"></div>
        </div>
      </div>
    </div>
    <div class="row" v-if="!item.erro">
      <div
        class="col-md-12 text-center"
        style="padding: 0"
        v-if="propSofaScore && item.evento && item.evento.sofaScore"
      >
        <div v-html="item.evento.sofaScore"></div>
      </div>
    </div>
    <div class="row" v-if="item.erro">
      <div class="col-md-12 text-center" style="margin-top: 40px">
        <h5 style="color: white">{{ item.erroMensagem }}</h5>
      </div>
    </div>
    <i
      v-if="retornaSite() == '7live'"
      class="d234fdsa2"
      :style="{ top: markTop + 'px' }"
      >{{ markText }}</i
    >

    <div class="card settings-menu p-1" style="width: 18rem" v-if="menuOpen">
      <div class="card-body text-center">
        <h5 class="card-title text-center">Opções</h5>
        <div>
          <div class="d-flex justify-content-center">
            <button
              class="btn btn-warning btn-sm"
              style="margin-right: 5px"
              @click="options.sofascore = !options.sofascore"
            >
              {{ options.sofascore == true ? "Sim" : "Nao" }}
            </button>
            <label
              class="form-check-label"
              style="margin-top: 4px; min-width: 75px"
              >Sofascore</label
            >
          </div>
          <div class="d-flex justify-content-center mt-2">
            <button
              class="btn btn-warning btn-sm"
              style="margin-right: 5px"
              @click="options.williamhill = !options.williamhill"
            >
              {{ options.williamhill == true ? "Sim" : "Nao" }}
            </button>
            <label
              class="form-check-label"
              style="margin-top: 4px; min-width: 75px"
              >WH Fixo</label
            >
          </div>
          <div class="d-flex justify-content-center mt-2" v-if="false">
            <button
              class="btn btn-info btn-sm"
              style="margin-right: 5px"
              @click="toggleFloat"
            >
              {{ options.williamhillFloat == true ? "Sim" : "Nao" }}
            </button>
            <label
              class="form-check-label"
              style="margin-top: 4px; min-width: 75px"
              >WH Flutuante</label
            >
          </div>
          <div class="form-check" v-if="false">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="options.replay"
              id="replay"
              @click="goReplay"
            />
            <label class="form-check-label" for="replay">Replay</label>
          </div>
        </div>
        <div class="mt-2">
          <a @click="menuOpen = false" class="card-link" style="cursor: pointer"
            >Fechar</a
          >
        </div>
      </div>
    </div>

    <div class="footer-wrapper" v-if="!menuOpen">
      <button
        class="btn btn-secondary footer-button"
        @click="toggleMenu"
        v-if="retornaSite() == 'Weddbets' || retornaSite() == 'Bll'"
      >
        Opções
      </button>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import { apiOpenVidu } from "@/services/apiOpenVidu.js";
import { apiAnt } from "@/services/apiAnt.js";
import { apiFlashphoner } from "@/services/apiFlashphoner.js";
import { apiMS } from "@/services/apiMS.js";
import util from "../includes/util.js";

let canvas_in;
let canvas_out;

let delay = 5;
let buffer = [];

export default {
  name: "ViewEvento",
  components: {},
  props: {
    propSofaScore: { type: Boolean, default: true },
  },
  data: function () {
    return {
      item: {
        evento: null,
        erro: false,
        token: "",
        erroMensagem: "",
      },
      lastWk: "",
      viewEventoOpen: {},
      menuOpen: false,
      options: {
        sofascore: false,
        williamhill: false,
        williamhillFloat: false,
        replay: false,
      },
      replayLoad: false,
      floatingIframe: {
        x: 100,
        y: 100,
        width: 600,
        height: 500,
        opacity: 0.9,
        isDragging: false,
        isResizing: false,
        startX: 0,
        startY: 0,
        startWidth: 0,
        startHeight: 0,
        showControls: false,
        scrollY: 0,
        iframeHeight: 900,
      },
    };
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    retornaSite() {
      return this.$site;
    },
    async carregarItem1(id) {
      console.log(id);
    },
    async carregarItem(id) {
      var parametros = "";

      if (this.$route.query.canal) {
        parametros = "?canal=" + this.$route.query.canal;
      }

      const response = await api.get("/evento/view/" + id + parametros);

      //* Verifica se econtrou
      if (response.data.erro == false && response.data.itens.length > 0) {
        this.viewEventoOpen = response.data.itens[0];

        let tituloEventoPre = "";

        if (
          this.$sessao.usuario.tipoUsuario == "Administrador" ||
          this.$sessao.usuario.tipoUsuario == "Apresentador"
        ) {
          if (
            Object.prototype.hasOwnProperty.call(
              this.viewEventoOpen,
              "dataHora"
            ) &&
            Object.prototype.hasOwnProperty.call(
              this.viewEventoOpen,
              "dataMinuto"
            )
          ) {
            tituloEventoPre =
              this.viewEventoOpen.dataHora.toString().padStart(2, "0") +
              ":" +
              this.viewEventoOpen.dataMinuto.toString().padStart(2, "0") +
              " - ";
          }
        }

        if (this.$route.query.canal) {
          document.title =
            "(" +
            this.$route.query.canal +
            ") " +
            tituloEventoPre +
            this.viewEventoOpen.nome;
        } else {
          document.title = tituloEventoPre + this.viewEventoOpen.nome;
        }

        this.item.evento = this.viewEventoOpen;
        this.item.evento.servidorTipo = this.item.evento.servidorTipo
          ? this.item.evento.servidorTipo
          : "openvidu";
        this.item.erro = false;

        if (this.item.evento.servidorTipo == "openvidu") {
          apiOpenVidu.entrarSessaoB(this.viewEventoOpen);
        } else if (this.item.evento.servidorTipo == "ant") {
          apiAnt.view(this.item.evento);
        } else if (this.item.evento.servidorTipo == "sh") {
          apiFlashphoner.initStream();
          apiFlashphoner.connectPlay(
            this.viewEventoOpen.key,
            this.item.evento,
            this.item.evento.canal
          );
        } else if (this.item.evento.servidorTipo == "ms") {
          apiMS.setUrl(this.item.evento.servidor);
          apiMS.setToken(this.item.evento.msToken);

          await apiMS.connect({ subscribe: true });
        }
      } else {
        this.item.erro = true;
        this.item.erroMensagem = response.data.mensagem;
      }
    },
    async sessionView() {
      var body = {
        token: this.viewEventoOpen.sessaoView,
      };

      try {
        await api.put("/sessaoView", body);
      } catch (error) {
        console.log(error);
      }
    },
    william(id) {
      return id.replace("OB_EV", "");
    },
    getView() {
      if (
        (this.$route.query.view && this.$route.query.view == "clean") ||
        this.$site == "7live"
      ) {
        return false;
      }

      return true;
    },
    apiFlashphoner() {
      return apiFlashphoner;
    },
    fullScreen() {
      if (!document.fullscreenElement) {
        document.getElementById("frameVideo").requestFullscreen();
      } else if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    },
    createWatermark() {
      const videoContainer = document.getElementById("msPlayVideo").parentNode;

      if (videoContainer) {
        const watermark = document.createElement("div");
        watermark.innerHTML =
          this.$sessao.usuario.site + "<br />" + this.$sessao.usuario.email;

        watermark.className = this.lastWk;
        watermark.style.position = "absolute";
        watermark.style.color = "rgba(218, 165, 255, 0.5)";
        watermark.style.backgroundColor = "rgba(0, 0, 0, 0.0)";
        watermark.style.padding = "5px 10px";
        watermark.style.borderRadius = "5px";
        watermark.style.pointerEvents = "none";
        watermark.style.zIndex = "10";
        watermark.style.fontSize = "10px";
        watermark.style.fontWeight = "bold";

        const x = Math.random() * (videoContainer.clientWidth - 164);
        const y = Math.random() * (videoContainer.clientHeight - 40);

        watermark.style.left = `${x}px`;
        watermark.style.top = `${y}px`;

        videoContainer.appendChild(watermark);
      }
    },
    ensureWatermark() {
      if (this.lastWk !== "") {
        const watermarks = document.querySelectorAll("." + this.lastWk);

        // Remove cada elemento selecionado
        watermarks.forEach((watermark) => {
          watermark.remove();
        });
      }

      this.lastWk = util.guidGenerator().replace(/[^a-zA-Z]/g, "");

      const videoContainer = document.getElementById("msPlayVideo").parentNode;

      if (videoContainer) {
        this.createWatermark();
      }
    },
    criarCanvas() {
      canvas_in = document.createElement("canvas");
      //canvas_in.width = "100%";
      canvas_in.width = 640;
      canvas_in.height = 360;
      canvas_in.style.position = "absolute";
      canvas_in.style.left = "-9999px";
      canvas_in.id = "canvas_in";
      document.body.appendChild(canvas_in);

      canvas_out = document.createElement("canvas");
      canvas_out.width = 640;
      canvas_out.height = 360;
      canvas_out.style.position = "absolute";
      canvas_out.style.left = "-9999px";
      canvas_out.id = "canvas_out";
      document.body.appendChild(canvas_out);
    },
    goReplay() {
      if (this.replayLoad == false) {
        this.replayLoad = true;

        this.criarCanvas();

        //* Carrega conteudo do video e desenha no canvas
        //const originalVideo = document.getElementById("msPlayVideo");

        /*let thisCall;

        originalVideo.oncanplay = function () {
          thisCall.goReplay();
        };*/

        //* Exemplo carrega do canvas e coloca em player
        let msPlayVideoBackup = document.getElementById("msPlayVideoBackup");
        //let canvas_out = document.getElementById("canvas_in");
        const stream = canvas_out.captureStream(30);
        msPlayVideoBackup.srcObject = stream;
      }

      let video = document.getElementById("msPlayVideo");
      //let canvas_in = document.getElementById("canvas_in");
      //let canvas_out = document.getElementById("canvas_out");

      let now = Date.now();
      let context = canvas_in.getContext("2d");

      // Set sizes of elements
      let width = video.videoWidth,
        height = video.videoHeight;
      let width_want = canvas_in.clientWidth;
      height *= width_want / width;
      width = width_want;

      canvas_in.width = width;
      canvas_in.height = height;
      canvas_out.width = width;
      canvas_out.height = height;

      //* Inverte a imagem
      //context.scale(-1, 1);
      //context.drawImage(video, 0, 0, -width, height);
      context.scale(1, 1);
      context.drawImage(video, 0, 0, width, height);

      //* Teste texto
      /*context.font = "bold 30px Arial";
context.fillStyle = "rgba(255, 255, 255, 0.8)"; // Cor branca com transparência
context.fillText("Live Streaming", 20, 50);*/

      //* Copia o buffer
      let data = context.getImageData(0, 0, width, height);
      buffer.push([now, data]);

      while (buffer.length >= 2 && buffer[0][0] < now - delay * 1000)
        buffer.shift();

      let context2 = canvas_out.getContext("2d");
      context2.putImageData(buffer[0][1], 0, 0);

      //* Atualiza novamente
      window.setTimeout(this.goReplay, 20);
    },
    toggleFloat() {
      this.options.williamhillFloat = !this.options.williamhillFloat;
      
      // Salvar preferência no localStorage
      localStorage.setItem('williamhillFloat', this.options.williamhillFloat);
      
      // Ao abrir, sempre posicionar no canto superior esquerdo
      if (this.options.williamhillFloat) {
        
        this.floatingIframe.x = 10;
        this.floatingIframe.y = 10;
        
        const saved = localStorage.getItem('floatingIframePosition');
        if (saved) {
          const position = JSON.parse(saved);
          this.floatingIframe.width = position.width || this.floatingIframe.width;
          this.floatingIframe.height = position.height || this.floatingIframe.height;
          this.floatingIframe.opacity = position.opacity || this.floatingIframe.opacity;
          this.floatingIframe.scrollY = position.scrollY || this.floatingIframe.scrollY;
          this.floatingIframe.iframeHeight = position.iframeHeight || this.floatingIframe.iframeHeight;
          this.floatingIframe.showControls = position.showControls !== undefined ? position.showControls : this.floatingIframe.showControls;
        }
      }
    },
    increaseOpacity() {
      if (this.floatingIframe.opacity < 1) {
        this.floatingIframe.opacity = Math.min(1, this.floatingIframe.opacity + 0.1);
        this.saveFloatingPosition();
      }
    },
    decreaseOpacity() {
      if (this.floatingIframe.opacity > 0.1) {
        this.floatingIframe.opacity = Math.max(0.1, this.floatingIframe.opacity - 0.1);
        this.saveFloatingPosition();
      }
    },
    startDrag(e) {
      this.floatingIframe.isDragging = true;
      this.floatingIframe.startX = e.clientX - this.floatingIframe.x;
      this.floatingIframe.startY = e.clientY - this.floatingIframe.y;
      
      document.addEventListener('mousemove', this.onDrag);
      document.addEventListener('mouseup', this.stopDrag);
      e.preventDefault();
    },
    onDrag(e) {
      if (this.floatingIframe.isDragging) {
        this.floatingIframe.x = e.clientX - this.floatingIframe.startX;
        this.floatingIframe.y = e.clientY - this.floatingIframe.startY;
      }
    },
    stopDrag() {
      this.floatingIframe.isDragging = false;
      document.removeEventListener('mousemove', this.onDrag);
      document.removeEventListener('mouseup', this.stopDrag);
      this.saveFloatingPosition();
    },
    startResize(e) {
      this.floatingIframe.isResizing = true;
      this.floatingIframe.startX = e.clientX;
      this.floatingIframe.startY = e.clientY;
      this.floatingIframe.startWidth = this.floatingIframe.width;
      this.floatingIframe.startHeight = this.floatingIframe.height;
      
      document.addEventListener('mousemove', this.onResize);
      document.addEventListener('mouseup', this.stopResize);
      e.preventDefault();
    },
    onResize(e) {
      if (this.floatingIframe.isResizing) {
        const deltaX = e.clientX - this.floatingIframe.startX;
        const deltaY = e.clientY - this.floatingIframe.startY;
        
        this.floatingIframe.width = Math.max(200, this.floatingIframe.startWidth + deltaX);
        this.floatingIframe.height = Math.max(150, this.floatingIframe.startHeight + deltaY);
      }
    },
    stopResize() {
      this.floatingIframe.isResizing = false;
      document.removeEventListener('mousemove', this.onResize);
      document.removeEventListener('mouseup', this.stopResize);
      this.saveFloatingPosition();
    },
    saveFloatingPosition() {
      const position = {
        x: this.floatingIframe.x,
        y: this.floatingIframe.y,
        width: this.floatingIframe.width,
        height: this.floatingIframe.height,
        opacity: this.floatingIframe.opacity,
        scrollY: this.floatingIframe.scrollY,
        iframeHeight: this.floatingIframe.iframeHeight,
        showControls: this.floatingIframe.showControls,
      };
      localStorage.setItem('floatingIframePosition', JSON.stringify(position));
    },
    toggleControls() {
      this.floatingIframe.showControls = !this.floatingIframe.showControls;
      this.saveFloatingPosition();
      console.log('Controles:', this.floatingIframe.showControls ? 'Visíveis' : 'Ocultos');
      
      // Enviar mensagem para o iframe
      const iframe = document.querySelector('.floating-iframe-container iframe');
      if (iframe && iframe.contentWindow) {
        const action = this.floatingIframe.showControls ? 'iframeControlsShown' : 'iframeControlsHidden';
        iframe.contentWindow.postMessage({ action }, '*');
      }
    },
    scrollUp() {
      this.floatingIframe.scrollY = Math.min(0, this.floatingIframe.scrollY + 30);
      this.saveFloatingPosition();
    },
    scrollDown() {
      const maxScroll = -(this.floatingIframe.iframeHeight - this.floatingIframe.height);
      this.floatingIframe.scrollY = Math.max(maxScroll, this.floatingIframe.scrollY - 30);
      this.saveFloatingPosition();
    },
    resetScroll() {
      // Recarrega o iframe
      const iframe = document.querySelector('.floating-iframe-container iframe');
      if (iframe) {
        const currentSrc = iframe.src;
        iframe.src = currentSrc;
      }
    },
    handleWrapperClick(e) {
      if (e.target.classList.contains('iframe-content-wrapper') || 
          e.target.classList.contains('hidden-controls-hint')) {
        console.log('Clique detectado no wrapper');
        this.toggleControls();
      }
    },
  },
  mounted() {
    //var thisCall = this;

    document.body.style.backgroundColor = "black";
    document.body.style.overflow = "hidden";
    document.getElementById("app").style["margin-top"] = "0";
    this.carregarItem(this.$route.params.id);
    document.addEventListener("contextmenu", function (e) {
      e.preventDefault();
    });

    if (this.$route.query.view && this.$route.query.view == "clean") {
      this.options.williamhill = false;
      this.options.sofascore = false;
    } else {
      this.options.williamhill = true;
      this.options.sofascore = true;
    }

    // Escutar mensagens do iframe para controlar visibilidade e movimento
    let dragStartPos = null;
    let initialIframePos = null;
    
    window.addEventListener('message', (event) => {
      if (event.data.action === 'toggleIframeControls') {
        this.toggleControls();
      } else if (event.data.action === 'startIframeDrag') {
        // Salvar posição inicial do drag
        dragStartPos = { x: event.data.clientX, y: event.data.clientY };
        initialIframePos = { x: this.floatingIframe.x, y: this.floatingIframe.y };
      } else if (event.data.action === 'stopIframeDrag') {
        // Limpar estado do drag
        dragStartPos = null;
        initialIframePos = null;
        this.saveFloatingPosition();
      } else if (event.data.action === 'moveIframe' && dragStartPos && initialIframePos) {
        // Calcular novo deslocamento
        const deltaX = event.data.clientX - dragStartPos.x;
        const deltaY = event.data.clientY - dragStartPos.y;
        
        // Atualizar posição do iframe
        this.floatingIframe.x = initialIframePos.x + deltaX;
        this.floatingIframe.y = initialIframePos.y + deltaY;
      }
    });

    setInterval(() => {
      this.sessionView();
    }, 15000);

    /*setInterval(function () {
      thisCall.ensureWatermark();
    }, 10000);*/

    this.markText = this.$sessao.usuario.email;
    
    /*const savedFloat = localStorage.getItem('williamhillFloat');
    if (savedFloat === 'true') {
      this.options.williamhillFloat = true;
      
      const savedPosition = localStorage.getItem('floatingIframePosition');
      if (savedPosition) {
        const position = JSON.parse(savedPosition);
        this.floatingIframe = { ...this.floatingIframe, ...position };
      }
    }*/
  },
  computed: {
    audioMudo: function () {
      return (
        this.$sessao.usuario.tipoUsuario == "Administrador" ||
        this.$sessao.usuario.tipoUsuario == "Apresentador"
      );
    },
  },
};
</script>

<style>
.settings-btn {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: transparent;
  border: none;
  outline: none;
}

.settings-btn i {
  font-size: 30px;
  color: gray;
}

.settings-btn svg {
  width: 20px;
  height: 20px;
  fill: gray;
}

.settings-menu {
  position: fixed;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px;
  border-radius: 5px;
}

.footer-wrapper {
  position: fixed;
  top: 0;
  width: 97%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.footer-button {
  opacity: 0;
  transition: opacity 0.3s ease;
  margin-top: 10px;
  pointer-events: none;
}

.footer-wrapper:hover .footer-button {
  opacity: 1;
  pointer-events: auto;
}

.d234fdsa1 {
  position: relative;
  left: 3%;
  top: 3%;
  color: white;
  animation: 30s d9df922f0d1 infinite;
}

.d234fdsa2 {
  position: absolute;
  color: white;
  animation: 60s d9df922f0d1 infinite;
  opacity: 0.5;
}

/* center */
.d234fdsa3 {
  position: fixed;
  top: 5%;
  left: 50%;
  color: white;
  animation: 60s d9df922f0d12 infinite;
  opacity: 0.6;
  transform: translate(-50%, -50%);
}

@keyframes d9df922f0d1 {
  0% {
    left: 3px;
    opacity: 0.5;
  }

  25% {
    opacity: 0;
  }

  50% {
    right: 3px;
    opacity: 0.5;
  }

  75% {
    opacity: 0;
  }
}

@keyframes d9df922f0d {
  0% {
    left: 3%;
    top: 3%;
  }

  25% {
    left: 87%;
    top: 3%;
  }

  50% {
    left: 87%;
    top: 87%;
  }

  75% {
    left: 3%;
    top: 87%;
  }

  100% {
    left: 3%;
    top: 3%;
  }
}

/* Estilos do Iframe Flutuante */
.floating-iframe-container {
  position: fixed;
  background: transparent;
  border: none;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: none;
  transition: opacity 0.2s ease;
}

.show-controls-btn-footer {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.6);
  color: white;
  padding: 4px 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  z-index: 10;
  transition: all 0.2s ease;
}

.show-controls-btn-footer:hover {
  border-color: rgba(255, 255, 255, 1);
  background: rgba(255, 255, 255, 0.15);
  transform: translateX(-50%) scale(1.05);
}

.show-controls-btn-footer:active {
  transform: translateX(-50%) scale(0.95);
}

.iframe-header {
  background: rgba(0, 0, 0, 0.9);
  padding: 8px;
  cursor: move;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  user-select: none;
  height: 40px;
  transition: all 0.3s ease;
}

.iframe-header.header-hidden {
  height: 0;
  padding: 0;
  opacity: 0;
  overflow: hidden;
}

.iframe-content-wrapper {
  overflow: hidden;
  position: relative;
  transition: height 0.3s ease;
  cursor: pointer;
}

.iframe-scroll-container {
  transition: margin-top 0.2s ease;
}

.iframe-controls {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
  justify-content: center;
}

.iframe-controls button {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  transition: background 0.2s;
}

.iframe-controls button:hover {
  background: rgba(255, 255, 255, 0.3);
}

.iframe-controls button:active {
  background: rgba(255, 255, 255, 0.4);
}

.iframe-controls button.btn-toggle {
  background: rgba(255, 193, 7, 0.3);
}

.iframe-controls button.btn-toggle:hover {
  background: rgba(255, 193, 7, 0.5);
}

.iframe-controls button.btn-hide {
  background: rgba(100, 149, 237, 0.3);
}

.iframe-controls button.btn-hide:hover {
  background: rgba(100, 149, 237, 0.5);
}

.iframe-controls span {
  color: white;
  font-size: 12px;
  min-width: 40px;
  text-align: center;
}

.iframe-controls .separator {
  color: rgba(255, 255, 255, 0.3);
  font-size: 16px;
  margin: 0 5px;
  min-width: auto;
}

.resize-handle {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px;
  height: 20px;
  cursor: nwse-resize;
  background: linear-gradient(135deg, transparent 50%, rgba(255, 255, 255, 0.3) 50%);
  z-index: 11;
}

.resize-handle:hover {
  background: linear-gradient(135deg, transparent 50%, rgba(255, 255, 255, 0.5) 50%);
}

.floating-iframe-container iframe {
  display: block;
  pointer-events: auto;
}
</style>
